import { PasswordResetStepGuard } from 'presentation/app/contexts/PasswordResetStepGuard';
import React from 'react';

import { ForgetPasswordPage } from './index';

export function ProtectedForgetPasswordPage() {
  return (
    <PasswordResetStepGuard step="cpf">
      <ForgetPasswordPage />
    </PasswordResetStepGuard>
  );
}
